module.exports = __webpack_public_path__ + "img/phi-home.815929e8.jpg";